import React from 'react';

const UiPanel = ({
  children,
  className = '',
  bodyClassName = '',
  title = '',
  subtitle = '',
  actions = null,
  headerClassName = '',
}) => {
  return (
    <section className={`rounded-2xl border border-gray-200 bg-white shadow-sm ${className}`}>
      {(title || subtitle || actions) && (
        <div className={`flex items-start justify-between gap-3 border-b border-gray-100 px-4 py-4 ${headerClassName}`}>
          <div className="min-w-0">
            {title ? <h3 className="text-base font-semibold text-gray-800">{title}</h3> : null}
            {subtitle ? <p className="mt-1 text-sm text-gray-500">{subtitle}</p> : null}
          </div>
          {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
        </div>
      )}
      <div className={bodyClassName || 'p-4'}>{children}</div>
    </section>
  );
};

export default UiPanel;
